import React, { useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { loginforced } from "../store/actions/homeActions";
import { Link } from "react-router-dom";
import GIFFE from "../assets/images/loading2.gif";
import { languageService } from "./lang/Lang.js";


function AutoLogin(props) {
  const { match, loginforcedFN } = props;


  useEffect(() => {
    // Update the document title using the browser API
   loginforcedFN(match.params.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container" style={{ marginTop: "60px" }}>
      <div className="columns" style={{ margin: 13, }}>
        <div
          className="column"
          style={{
            color: "#3C2200",
            padding: "10px !important",
            textAlign: "center"
          }}
        >
          <div style={{ height: "10px" }}></div>
          <img style={{ height: "100px", textAlign: "center" }} alt="loading" src={GIFFE} />
          <div style={{ height: "20px" }}></div>

          <p>{languageService.translate('autologin.t1')} <Link to="/login" style={{ color: "#F883A0" }}>{languageService.translate('autologin.t2')}</Link> {languageService.translate('autologin.t3')}</p>




        </div>
      </div>
    </div>
  );
}



const mapDispatchToProps = (dispatch) => {
  return {
    loginforcedFN: (username, pwd) =>
      dispatch(loginforced(username, pwd)),

  };
};

export default compose(connect(null, mapDispatchToProps))(
  AutoLogin
);
